import { IPublicClientApplication } from "@azure/msal-browser";
import { IMsalAuthService } from "../../../core/msal/msalAuthService";

export class UnexpectedStateController implements ng.IController {
    withLogoutLink: boolean;

    static $inject = ['$stateParams', 'MsalAuthService'];

    constructor(private _$stateParams: angular.ui.IStateParamsService,
        private msalAuthService: IMsalAuthService) {
    }

    $onInit() {
        this.withLogoutLink = this._$stateParams['link'] === 'logout';
    }

    logout(): void {
        this.msalAuthService.msal().logoutRedirect();
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/unexpected/controllers/unexpectedStateController.ts
 **/